import { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navLinks = [
    { to: '/', label: '首頁', icon: 'ri-home-4-line' },
    { to: '/about', label: '關於我們', icon: 'ri-information-line' },
    { to: '/services', label: '服務項目', icon: 'ri-service-line' },
    { to: '/service-area', label: '台北/新北搬家服務', icon: 'ri-map-pin-line' },
    { to: '/pricing', label: '搬家費用計算方式', icon: 'ri-calculator-line' },
    { to: '/cases', label: '搬家服務案例', icon: 'ri-gallery-line' },
    { to: '/knowledge', label: '搬家知識', icon: 'ri-book-open-line' },
    { to: '/faq', label: '常見問題', icon: 'ri-question-line' },
    { to: '/contact', label: '聯絡我們', icon: 'ri-customer-service-line' }
  ];

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <h1 className="text-xl sm:text-2xl font-bold text-blue-600" style={{ fontFamily: '"Pacifico", serif' }}>
              建鈞精緻搬家
            </h1>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap text-sm font-medium flex items-center gap-1.5 group"
              >
                <i className={`${link.icon} text-base group-hover:scale-110 transition-transform`}></i>
                <span>{link.label}</span>
              </Link>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
            aria-label="選單"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="lg:hidden pb-4 border-t border-gray-200 mt-2 pt-4">
            <div className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-gray-700 hover:text-blue-600 hover:bg-blue-50 transition-colors cursor-pointer px-4 py-2 rounded-lg font-medium flex items-center gap-3"
                >
                  <i className={`${link.icon} text-lg`}></i>
                  <span>{link.label}</span>
                </Link>
              ))}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;